import React from 'react';
import { Volume2 } from 'lucide-react';
interface AudioPlayerProps {
  src: string;
  title: string;
  subtitle?: string;
}
export function AudioPlayer({
  src,
  title,
  subtitle
}: AudioPlayerProps) {
  return <div className="bg-white border border-[#E8E8E6] rounded-xl p-5 shadow-sm space-y-3" data-id="element-45">
      <div className="flex items-center gap-3" data-id="element-46">
        <div className="w-10 h-10 rounded-full bg-[#5BBFB5]/10 flex items-center justify-center shrink-0" data-id="element-47">
          <Volume2 className="w-5 h-5 text-[#5BBFB5]" data-id="element-48" />
        </div>
        <div className="min-w-0" data-id="element-49">
          <h4 className="font-medium text-[#3A3A3A] truncate" data-id="element-50">{title}</h4>
          {subtitle && <p className="text-sm text-[#7A7A7A] truncate font-light" data-id="element-51">
              {subtitle}
            </p>}
        </div>
      </div>

      <audio controls preload="metadata" className="w-full" style={{
      height: '40px'
    }} data-id="element-52">
        <source src={src} type="audio/mpeg" data-id="element-53" />
        Tu navegador no soporta la reproducción de audio.
      </audio>
    </div>;
}